var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgForgotPasswordLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 136 124",
    style: {
      enableBackground: "new 0 0 136 124"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EFFCFC;}\n\t.st1{opacity:0.7;fill:#EFFCFC;enable-background:new    ;}\n\t.st2{fill:#D9D9D9;filter:url(#Adobe_OpacityMaskFilter);}\n\t.st3{mask:url(#mask0_1385_3439_00000033356281183306433160000016133126313198274951_);}\n\t.st4{fill:#028383;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.8,2.3c0,0-23.2-7.1-44.5,6.8C21,23.1,11.6,49.2,3.4,70.2c-8.2,21-1.2,41.7,16.5,50.5 c17.6,8.8,28.2-5.8,51.9-7.5s30.4,1.4,49.2-13c18.8-14.5,20.1-46.7,2.9-69.7C106.6,7.4,86.8,2.3,86.8,2.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.8,2.3c0,0-23.2-7.1-44.5,6.8C21,23.1,11.6,49.2,3.4,70.2c-8.2,21-1.2,41.7,16.5,50.5 c17.6,8.8,28.2-5.8,51.9-7.5s30.4,1.4,49.2-13c18.8-14.5,20.1-46.7,2.9-69.7C106.6,7.4,86.8,2.3,86.8,2.3z"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 43.8,
    y: 32.1,
    width: 47.5,
    height: 60.2
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 43.8,
    y: 32.1,
    width: 47.5,
    height: 60.2,
    id: "mask0_1385_3439_00000033356281183306433160000016133126313198274951_"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 19.4,
    className: "st2",
    width: 85,
    height: 84.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M66.3,84h2.5V73.4h10.6V71H68.7V60.4h-2.5V71H55.6v2.5h10.6V84z M49.1,92.2c-1.5,0-2.7-0.5-3.8-1.6 c-1-1-1.6-2.3-1.6-3.7V57.4c0-1.5,0.5-2.7,1.6-3.7c1-1,2.3-1.6,3.8-1.6h5.3v-7c0-3.6,1.3-6.7,3.8-9.2c2.5-2.5,5.6-3.8,9.3-3.8 c3.7,0,6.8,1.3,9.3,3.8c2.5,2.5,3.8,5.6,3.8,9.2v7h5.3c1.5,0,2.7,0.5,3.8,1.6c1,1,1.6,2.3,1.6,3.7V87c0,1.5-0.5,2.7-1.6,3.7 c-1,1-2.3,1.6-3.8,1.6H49.1z M56.9,52.1h21.2v-7c0-2.9-1-5.4-3.1-7.5c-2.1-2.1-4.6-3.1-7.5-3.1c-3,0-5.5,1-7.5,3.1 c-2.1,2.1-3.1,4.5-3.1,7.5V52.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForgotPasswordLogo);
export default __webpack_public_path__ + "static/media/forgotPasswordLogo.891cfdb0aefbe44d1d01b3e803fb73ec.svg";
export { ForwardRef as ReactComponent };